import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import CustomDescription from './CustomDescription';
import { PRACTICE_SECTION_TITLE } from './constants';
import { safeGet } from '../../../core/util/object';
import { isEmptyString } from '../../../core/util/string';

const CustomDescriptionSection = props => {
  const { location } = props;
  const customDescription = safeGet(location, '')('customDescription');
  if (isEmptyString(customDescription)) {
    return null;
  }
  return (
    <Fragment>
      {PRACTICE_SECTION_TITLE} <br />
      <CustomDescription location={location} />
    </Fragment>
  );
};

CustomDescriptionSection.propTypes = {
  location: PropTypes.object,
};

export default CustomDescriptionSection;
